"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbHybridSessionV2 = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const events_1 = require("../../../../security/events");
const timeOut_helper_1 = require("../../../../security/timeOut/helpers/timeOut.helper");
class MbHybridSessionV2 extends web_ui_security_1.BaseSession {
    constructor(sessionStorage, refreshToken) {
        super(sessionStorage);
        this.parseRefreshToken = (data) => {
            const parseData = JSON.parse(data);
            const decode = web_ui_framework_1.AdvanceDecode.object({
                accessToken: web_ui_framework_1.AdvanceDecode.field('access_token', web_ui_framework_1.BasicDecode.string),
                expiresIn: web_ui_framework_1.AdvanceDecode.field('expires_in', web_ui_framework_1.BasicDecode.int),
            });
            return decode(parseData);
        };
        this.doRefresh = async () => {
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const data = await this.refreshToken();
                const { accessToken, expiresIn } = this.parseRefreshToken(data);
                const newSessionData = {
                    accessToken,
                    expiresIn,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken) {
                return true;
            }
            return false;
        };
        this.refreshToken = refreshToken;
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback);
    }
}
exports.MbHybridSessionV2 = MbHybridSessionV2;
//# sourceMappingURL=index.js.map